import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb, Typography } from "antd";
import { RightOutlined } from "@ant-design/icons";
const { Item } = Breadcrumb;
const { Text } = Typography;

const GxBreadCrumb = ({ breadCrumbItems }) => {
  return (
    <Breadcrumb
      className="bg-inherit no-screenshot"
      separator={<RightOutlined className="size-3 font-semibold" />}
    >
      {breadCrumbItems.map((item, i) => {
        const bcLength = breadCrumbItems.length;
        const isLast = i == bcLength - 1;
        const isLastColor = isLast ? "#6940F2" : "#616874";

        return (
          <Item key={item.label}>
            {item?.link && false ? ( // for now we don't need to show the Link so adding && false
              <Link to={item?.link}>
                <Text className="text-blue-500 text-xs" underline>
                  {item.label}
                </Text>
              </Link>
            ) : (
              <Text
                className="text-xs"
                style={{
                  color: isLastColor,
                  fontWeight: isLast ? "bold" : "normal",
                }}
              >
                {item.label}
              </Text>
            )}
          </Item>
        );
      })}
    </Breadcrumb>
  );
};

export default GxBreadCrumb;
